import { Node, mergeAttributes } from '@tiptap/core';
import { SvelteNodeViewRenderer } from 'svelte-tiptap';
import { type Node as ProseMirrorNode } from '@tiptap/pm/model';

import BhsnSlotReferenceComponent from './BhsnSlotReferenceComponent.svelte';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        slotReference: {
            mapSlotReferenceAttributes: (mapper: (node: ProseMirrorNode) => ProseMirrorNode['attrs'] | null) => ReturnType;
        };
    }
}

export const BhsnSlotReferenceExtension = Node.create({
    name: 'slotReference',
    group: 'block',
    content: 'block+',
    inline: false,
    defining: true,
    selectable: true,
    isolating: true,

    addAttributes() {
        return {
            'data-id': { default: '', required: true },
            'data-name': { default: '', required: true },
        };
    },

    parseHTML() {
        return [{ tag: 'svelte-counter-component' }];
    },

    renderHTML({ HTMLAttributes }) {
        return ['bhsn-slot-reference', mergeAttributes(HTMLAttributes)];
    },

    addCommands() {
        return {
            mapSlotReferenceAttributes:
                (mapper: (node: ProseMirrorNode) => ProseMirrorNode['attrs'] | null) =>
                ({ tr, state, dispatch }) => {
                    state.doc.descendants((node, pos) => {
                        if (node.type === state.schema.nodes.slotReference) {
                            const attributes = mapper(node);
                            if (attributes) {
                                tr.setNodeMarkup(pos, null, { ...node.attrs, ...attributes });
                                if (dispatch) dispatch(tr);
                            }
                        }
                    });
                    return true;
                },
        };
    },

    addNodeView() {
        return SvelteNodeViewRenderer(BhsnSlotReferenceComponent);
    },
});
